import { PhoneIcon } from '@chakra-ui/icons'
import { FaMapMarkerAlt } from "react-icons/fa"
import { Box, Center, Flex, Spacer, Text, Icon } from '@chakra-ui/react'
import { StaticImage } from 'gatsby-plugin-image'
import React from 'react'

const Section = ({title, children, variant, ...props}) => {
  return (
    <Flex
      justifyContent="center"
      flexDirection="column"
      minH="100vh"
      bg={variant === "black" ? "black" : ""}
      {...props}
    >
      <Flex>
        <Spacer />
        <Center
          color="primary"
          px="5"
          width="100%"
          fontWeight="bold"
          fontSize="4xl"
          bg={variant === "black" ? "" : "white"}
          shadow="dark-lg"
        >
          {title}
        </Center>
        <Spacer />
      </Flex>
      <Spacer />
      <Box>{children}</Box>
      <Spacer />
    </Flex>
  )
}

export const PriceSection = ({title, prices=[]}) => {
  return (
    <Box bg="white" w={{base: "75%",sm: "50%", md: "35%", lg:"25%"}} m="2" p="6" color="black">
      <Center mb="2" fontWeight="bold" fontSize="3xl">
        {title}
      </Center>
      {prices.map((price, index) => (
        <Flex key={index} alignItems="baseline" mb="4">
          <Text>{price.name}</Text>
          <Text
            style={{ borderBottom: "2px dotted #333" }}
            flex="1"
            mx="2"
          ></Text>
          <Text>{price.value}</Text>
        </Flex>
      ))}
    </Box>
  )
}
export const HourSection = ({ title, hours = [] }) => {
  return (
    <Flex color="white">
      <Spacer />
      <Box w="50%">
        {hours.map((hour, index) => (
          <Flex key={index} alignItems="baseline" mb="4">
            <Text>{hour.name}</Text>
            <Text
              style={{ borderBottom: "2px dotted #333" }}
              flex="1"
              mx="2"
            ></Text>
            <Text>{hour.value}</Text>
          </Flex>
        ))}
      </Box>
      <Spacer />
    </Flex>
  )
}

export const ContactSection = ({ phone, address }) => {
  return (
    <Flex>
      <Spacer />
      <Box border="1px" w="70%" bg="white" color="black">
        <Flex flexDirection="column">
          <StaticImage
            src="../images/outdoor.jpg"
            layout="constrained"
            quality={95}
            formats={["AUTO", "WEBP", "AVIF"]}
            alt="Outdoor"
          />
          <Box p="3">
            <Flex>
              <PhoneIcon />
              <Text ml="3">{phone}</Text>
            </Flex>
            <Flex>
              <Icon as={FaMapMarkerAlt} />
              <Text ml="3">{address}</Text>
            </Flex>
          </Box>
        </Flex>
      </Box>
      <Spacer />
    </Flex>
  )
}

export default Section;